import ContextGeoLocationModel from './geoLocation.model.js';
export default {
    name: 'ContextGeo',
    properties: {
        ip: {},
        location: { type: 'model', model: ContextGeoLocationModel },
    },
};
